import {
  getCookie,
  setCookie,
  updateCookie,
} from '@/lib/utils';
import store from '@/store';


export default function useSmartTerminalCookie() {
  const COOKIENAME = 'loft-smart-terminal';
  const DURATION = 365;

  const isValidTerminalId = (smartTerminalId) => {
    return store.getters['auth/isValidTerminalId'](smartTerminalId);
  };

  const getSmartTerminalCookie = () => {
    const cookie = getCookie(COOKIENAME);
    return cookie || null;
  };

  const setSmartTerminalCookie = (smartTerminalId) => {
    if (!isValidTerminalId(smartTerminalId)) return;
    setCookie(COOKIENAME, smartTerminalId, DURATION);
  };

  const updateSmartTerminalCookie = (smartTerminalId) => {
    if (!isValidTerminalId(smartTerminalId)) return;
    updateCookie(COOKIENAME, smartTerminalId, DURATION);
  };

  return {
    getSmartTerminalCookie,
    setSmartTerminalCookie,
    updateSmartTerminalCookie,
  };
}
